import React from 'react';
import ReactSlider from 'rc-slider';

import Input from '@components/uikit/Input/Input';

import { toCurrency } from '@helpers/helper';

import style from './style.module.scss';
import 'rc-slider/assets/index.css';

interface IProps {
  label?: string;
  from: number;
  to: number;
  min?: number;
  max?: number;
  step?: number;
  startInput?: React.ReactElement;
  showToCurrency?: boolean;
  onChange: (values: number[]) => void;
};

const Slider: React.FC<IProps> = ({
  label,
  from,
  to,
  min,
  max,
  step,
  onChange,
  startInput,
  showToCurrency = false,
}) => {
  return (
    <div className={style.fieldBlock}>
      {label && <label className={style.sliderLabel}>
        {label}
      </label>}
      <div className={style.sliderRangeBlock}>
        <Input
          value={showToCurrency ? toCurrency(from) : from}
          leftElement={startInput}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            const localLeft = parseFloat(event.target.value.replaceAll(',', ''));
            const left = localLeft > max! ? max : localLeft < min! ? min : localLeft;
            onChange([left!, to]);
          }}
          type={'woHelperText'}
        />
        <ReactSlider
          range
          value={[from || 0, to || 0]}
          onChange={(values) => onChange(values as number[])}
          min={min}
          max={max}
          step={step || 1}
          className={style.sliderWrapper}
        />
        <Input
          value={showToCurrency ? toCurrency(to) : to}
          leftElement={startInput}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            const localRight = parseFloat(event.target.value.replaceAll(',', ''));
            const right = localRight > max! ? max : localRight < min! ? min : localRight;
            onChange([from, right!]);
          }}
          type={'woHelperText'}
        />
      </div>
    </div>
  );
};

export default Slider;
